import { useQuery } from 'react-query'
import { fetchWorkflow } from 'workflow/shared/api'

import { FetchWorkflowResponse } from 'workflow/shared/types'

export default function useWorkflow({
  workflowUuid
}: {
  workflowUuid?: string
}) {
  const { data, isFetching } = useQuery<FetchWorkflowResponse>(
    ['workflow', workflowUuid],
    () => {
      return fetchWorkflow(workflowUuid)
    }
  )

  return {
    workflow: data?.data?.workflow,
    isFetching
  }
}
